import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { EndpointService } from '@app/core';
import { DocumentoAnexo } from '@app/shared';

export interface DowloadFile {
  path: string;
  name: string;
}

@Injectable()
export class AttachedDocumentDataService {
  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private api: EndpointService
  ) { }

  /**
   * Consulta de los documentos anexados a una tarea
   *
   * @param {number} idProcedure
   * @returns {Observable<DocumentoAnexo>}
   * @memberof DynamicFormsDataService
   */
  getAttachedDocument(idProcedure: number): Observable<DocumentoAnexo[]> {
    return new Observable(obs => {
      this.http.get<DocumentoAnexo[]>(this.api.get('attachedDocumentProcedure', [idProcedure])).subscribe(
        documentsAttached => {
          obs.next(documentsAttached);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  /**
   * Descargar documento anexado
   *
   * @param {number} idTask
   * @returns {Observable<DowloadFile>}
   * @memberof DynamicFormsDataService
   */
  getDownloadAttachedDocument(idTask: number): Observable<DowloadFile> {
    return new Observable(obs => {
      this.http.get<DowloadFile>(this.api.get('downloadAttachedDocument', [idTask])).subscribe(
        file => {
          obs.next(file);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  /**
   * Sube los documentos cargados al sistema
   *
   * @param {FormData} formData
   * @returns {Promise<DocumentoAnexo[]>}
   * @memberof DynamicFormsDataService
   */
  addAttachedDocument(formData: FormData): Promise<DocumentoAnexo[]> {
    return new Promise((resolve, reject) => {
      this.http.post<DocumentoAnexo[]>(this.api.get('attachedDocument'), formData).subscribe(
        form => {
          resolve(form);
          this.toastr.success('Operación exitosa', 'Los anexos fueron enviados correctamente');
        },
        err => {
          reject(err);
        }
      );
    });
  }

  /**
   * Elimina un documento anexado
   *
   * @param {number} idAttahed
   * @returns {Promise<boolean>}
   * @memberof DynamicFormsDataService
   */
  deleteAttachedDocument(idAttahed: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.delete<boolean>(this.api.get('attachedDocument', [idAttahed])).subscribe(
        resp => {
          resolve(resp);
          this.toastr.success('Operación exitosa', 'El documento se elimino correctamente');
        },
        err => {
          reject(err);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/attached-document-exp/shared/attached-document-exp.data.service.ts